var React = require('react');

function BoxLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Kawa","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"kawa-","transform":"translate(-157.000000, -6163.000000)","fill":"#F5CFC7"},React.createElement("g",{"id":"Group-22","transform":"translate(157.000000, 6163.000000)"},React.createElement("polygon",{"id":"Rectangle","transform":"translate(172.500000, 137.202026) scale(-1, 1) translate(-172.500000, -137.202026) ","points":"0 1.42108547e-13 345 35 345 234.458801 264.267029 259 7 274.404053"})))));
}

BoxLeft.defaultProps = {"preserveAspectRatio":"none","width":"345px","height":"275px","viewBox":"0 0 345 275","version":"1.1"};

module.exports = BoxLeft;

BoxLeft.default = BoxLeft;
